class Video {
  constructor (data) {
    this.id = data ? data.id : ''
    this.name = data ? data.name : ''
    this.video_no = data ? data.video_no : ''
    this.sort_no = data ? data.sort_no : 0
    // eslint-disable-next-line eqeqeq
    this.is_enabled = data ? (data.is_enabled == 1) : true
    this.thumbnail = data ? data.thumbnail : null
    this.thumbnailUrl = data ? data.thumbnailUrl : null
    this.MP4 = data ? data.MP4 : null
    this.downloads = data ? data.downloads : -1
  }

  getFormData () {
    let formData = new FormData()
    formData.append('id', this.id)
    formData.append('name', this.name)
    formData.append('video_no', this.video_no)
    formData.append('sort_no', this.sort_no)
    formData.append('is_enabled', this.is_enabled === true)
    formData.append('thumbnail', this.thumbnail)
    formData.append('MP4', this.MP4)
    return formData
  }
}

export default Video



// WEBPACK FOOTER //
// ./src/models/Video.js